import { takeEvery, put } from "redux-saga/effects";
import { GA_CATEGORIES, GA_EVENTS } from "../../data/ga-constants";
import { getErrorMessage, pos_errormap_without_label } from "../../helpers/errors-helper";
import { sendGTMEvent } from "../../helpers/ga-helpers";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";
import { getUserDetails, registerFCMToken, resetRequestHeaderData, saveLoginData, saveUserDetails, userLogout, validateUserData } from "../slices";
import { setLocalStorage } from "../../utils";
import { FCM_TOKEN } from "../../data/local-storage-constants";
import { AxiosRequestConfig } from "axios";
import { METHODS } from "../../data/api-method-constants";
import { registerFCM } from "../../helpers/notification-helpers";
interface CustomRequestConfig extends AxiosRequestConfig {
  customUrl?: boolean;
  hideLoader?: boolean;
}

export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  code?: string;
}

function* validateUser(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.LOGIN.validateUserApi,
      data: actions.payload.dataToPost,
    });
    if (response.code) {
      let dataToPost = actions?.payload?.dataToPost;
      let data = {
        event_category: GA_CATEGORIES.LOGIN,
        event_label: dataToPost?.accountNumber,
        non_interaction: false,
        user_id: dataToPost?.userId,
        reason: getErrorMessage(pos_errormap_without_label, response.code),
      };
      sendGTMEvent({ eventName: GA_EVENTS.LOGIN_FAIL, data });
    }
    if (!response?.code || response?.code !== 'REST_AUTHENTICATION_FAILED') {
      yield put(saveLoginData(response));
      const data = response as any;
      registerFCM();
      actions.payload.callback(true);
    } else {
      actions.payload.callback(false);
    }
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

function* logoutUser(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.LOGIN.logoutUserApi,
    });
    window.postMessage({ detail: { message: { ACTION: "LOGOUT_USER" } } });
    actions.payload.callback && actions.payload.callback();
    yield put(resetRequestHeaderData());
  } catch (error) {
    actions.payload.callback && actions.payload.callback();
    console.log(error);
  }
}

function* fetchUserDetails(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.LOGIN.userDetailsApi(actions?.payload?.businessUserId)
    })
    if (!response?.code) {
      yield put(saveUserDetails(response))
      actions.payload?.callback && actions.payload.callback(response);
    }
  } catch (error) {
    console.log(error);
  }
}

function* registerFCMTokenApi(action: any) {
  let { fcmToken }  = action.payload;
  try {
    const response: ResponseGenerator = yield api.request<CustomRequestConfig>({
      method: METHODS.POST,
      url: ENDPOINT.LOGIN.registerFCM(fcmToken),
      customUrl: true,
      hideLoader: true,
    } as CustomRequestConfig);
    setLocalStorage(FCM_TOKEN, fcmToken);
  } catch (error){
    console.log('error', error);
  }
}

export default function* root() {
  yield takeEvery(validateUserData.type, validateUser);
  yield takeEvery(userLogout.type, logoutUser);
  yield takeEvery(getUserDetails.type, fetchUserDetails);
  yield takeEvery(registerFCMToken.type, registerFCMTokenApi);
}
